import type { SharedRoomOfferState } from '@/hooks/useSharedRoomOffer'

/** User confirmed merge/join on the detection modal. */
export function confirmSharedRoomDetection(input: {
  offerKind: SharedRoomOfferState['kind']
  hasDismissedSnapshot: boolean
  acceptOffer: () => boolean
  acceptDismissedMatch: () => boolean
}): boolean {
  if (input.offerKind === 'offered') {
    return input.acceptOffer()
  }
  if (input.hasDismissedSnapshot) {
    return input.acceptDismissedMatch()
  }
  return false
}
